import { useEffect } from 'react';
import '../../../mk8dx/Mk8dxApp.css';
import '../../../world/WorldApp.css';

/**
 * Wrapper component for shared/standalone pages (auth, profile, etc.)
 * @param {string} game - The game theme to use ('mk8dx' or 'world'). Defaults to 'mk8dx'
 */
function SharedPageWrapper({ children, game = 'mk8dx' }) {
  useEffect(() => {
    if (game === 'world') {
      document.body.classList.add('world-theme');
      document.body.classList.remove('mk8dx-theme');
    } else {
      document.body.classList.add('mk8dx-theme');
      document.body.classList.remove('world-theme');
    }
    return () => {
      document.body.classList.remove('mk8dx-theme', 'world-theme');
    };
  }, [game]);

  return (
    <div className={game === 'world' ? 'world-app' : 'mk8dx-app'}>
      {children}
    </div>
  );
}

export default SharedPageWrapper;
